/*
 * Action types for the multi-exam marking grid and subsection marking.
 *
 * These live outside Actions/Exam because that module is owned elsewhere;
 * the sagas are registered from Sagas/School/multiExam.
 */
export const GET_MULTI_EXAM_VERIFY = 'GET_MULTI_EXAM_VERIFY'
export const SAVE_MULTI_EXAM_VERIFY = 'SAVE_MULTI_EXAM_VERIFY'
export const GET_MULTI_EXAM_GRID = 'GET_MULTI_EXAM_GRID'

export const GET_SUBSECTION_EXAMS = 'GET_SUBSECTION_EXAMS'
export const SAVE_SUBSECTION_EXAMS = 'SAVE_SUBSECTION_EXAMS'
export const GET_SUBSECTION_EXAM_RESULTS = 'GET_SUBSECTION_EXAM_RESULTS'
export const SAVE_SUBSECTION_EXAM_MARKS = 'SAVE_SUBSECTION_EXAM_MARKS'
export const RECALCULATE_EXAM_TOTALS = 'RECALCULATE_EXAM_TOTALS'
